import {
	PopoverRoot,
	PopoverPortal,
	PopoverTrigger,
	PopoverContent,
	PopoverAnchor,
	PopoverButton
} from './Popover';

export const Popover = {
	Root: PopoverRoot,
	Portal: PopoverPortal,
	Trigger: PopoverTrigger,
	Content: PopoverContent,
	Anchor: PopoverAnchor,
	Button: PopoverButton
};
